import { render } from "./ContactOfficesPage.vue?vue&type=template&id=255dde73"
import script from "./ContactOfficesPage.vue?vue&type=script&lang=js"
export * from "./ContactOfficesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__